import React, { Component } from "react";
import { MDBRow, MDBCol, MDBContainer, MDBCard, MDBCardBody, MDBCardText } from "mdbreact";
import axios from "axios";
import MetaTags from "react-meta-tags";
import packkagee from "../../package.json";
import { Button, Pane } from "evergreen-ui";
import { BsCardChecklist } from "react-icons/bs";
import { AiOutlineFileSearch } from "react-icons/ai";
import Swal from "sweetalert2";
import { mua } from "./MUA";
import { admission } from "./ADMISSION";
export default class Checkregister extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 1,
      citizent: "",
      titlename: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    localStorage.clear();
    // if(this.props.match.params.param === "1"){
    //     this.setState({ titlename: "พิมพ์ใบชำระเงินค่าสมัคร" })
    // }else if(this.props.match.params.param === "2"){
    //     this.setState({ titlename: "ตรวจสอบผลสมัคร/พิมพ์ใบสมัคร" })
    // }else if(this.props.match.params.param === "3"){
    //     this.setState({ titlename: "ตรวจสอบผลการคัดเลือก" })
    // }else if(this.props.match.params.param === "4"){
    //     this.setState({ titlename: "พิมพ์ใบชำระเงินรายงานตัว" })
    // }
    this.setState({ titlename: "ตรวจสอบสถานะ" });
  }

  handleChange(event) {
    event.preventDefault();
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.state.citizent = this.state.citizent.replace("/", ",");

    // console.log(this.state.citizent)

    axios.get(mua + "/admissionnew2022/showlistregister?id=" + this.state.citizent).then((res) => {
      const studentok = res.data.data.data.filter(
        ({ ROB_ID, Major1_MAJOR_ID, REGISTER_STATUS }) =>
          !(ROB_ID === "91" && Major1_MAJOR_ID === "1104" && REGISTER_STATUS === "11")
      );
      // studentok.filter(
      //   ({ ROB_ID}) =>
      //     !(ROB_ID === "156" ||ROB_ID === "157"||ROB_ID === "158")
      // )
      // const result = studentok.some(({ ROB_ID }) => (ROB_ID !== "156" && ROB_ID !== "157"  && ROB_ID !== "158" ))
      // ? 0
      // : studentok.filter(({ ROB_ID }) => !["156", "157", "158"].includes(ROB_ID));
      // console.log(result)
      // const ss = studentok.some(({ ROB_ID }) => ROB_ID === "160") ? "ff" : "aa";
      if (studentok.length !== 0) {
        // console.log(filteredStudents)

        // if (ss === "aa") {
        if (studentok.length !== 0) {
          // if (
          //   (studentok[0]["REGISTER_TYPE_ID"] !== "1" && studentok[0]["REGISTER_TYPE_ID"] !== "5") ||
          //   this.props.match.params.param === "พี่อ้อ"
          // ) {
          console.log(studentok);
          // if (studentok[0]["ROB_I D"] !== "139" && studentok[0]["ROB_ID"] !== "138" && studentok[0]["ROB_ID"] !== "137" && studentok[0]["ROB_ID"] !== "140" && studentok[0]["ROB_ID"] !== "144" && studentok[0]["ROB_ID"] !== "140") {
          let rob = "";
          studentok.forEach((element) => {
            if (element.ROB_ID === "131") {
              rob = "131";
            }
          });
          if (rob !== "131x") {
            Swal.fire({
              icon: "success",
              title: "ยินดีต้อนรับ",
              timer: 1500,
              timerProgressBar: true,
              showConfirmButton: false,
            }).then((res) => {
              localStorage.setItem("citizent", this.state.citizent);
              localStorage.setItem("statustitle", this.state.titlename);
              localStorage.setItem("ID_LOGIN", studentok[0]["ID_LOGIN"]);
              this.setState({ status: studentok.length });
              if (
                studentok[0]["REGISTER_STATUS"] === "0" ||
                studentok[0]["REGISTER_STATUS"] === "1" ||
                studentok[0]["REGISTER_STATUS"] === "2" ||
                studentok[0]["REGISTER_STATUS"] === "3" ||
                studentok[0]["REGISTER_STATUS"] === "4" ||
                studentok[0]["REGISTER_STATUS"] === "41" ||
                studentok[0]["REGISTER_STATUS"] === "5" ||
                studentok[0]["REGISTER_STATUS"] === "11" ||
                studentok[0]["REGISTER_STATUS"] === "12" ||
                studentok[0]["REGISTER_STATUS"] === "91"
              ) {
                window.location.href = "/" + packkagee.name + "/Dataregister";
              } else if (
                studentok[0]["REGISTER_STATUS"] === "6" ||
                studentok[0]["REGISTER_STATUS"] === "7" ||
                studentok[0]["REGISTER_STATUS"] === "8" ||
                studentok[0]["REGISTER_STATUS"] === "9"
              ) {
                // window.location.href = "/"+packkagee.name+"/present";
                if (studentok[0]["ROB_ID"] === "126") {
                  window.location.href = "/" + packkagee.name + "/Dataregister";
                } else if (studentok[0]["ROB_ID"] !== "88") {
                  axios
                    .get(admission + "/student/creckprecent1/" + studentok[0]["REGISTER_ID"])
                    .then((response) => {
                      if (response.data === 0) {
                        window.location.href = "/" + packkagee.name + "/Dataregister";
                      } else {
                        localStorage.setItem("statusHeader", "1");
                        // window.location.href = "/" + packkagee.name + "/Checkpresent";
                        if (studentok[0]["ROB_ID"] === "141") {
                          window.location.href = "/" + packkagee.name + "/DataregisterOld";
                        } else {
                          window.location.href = "/" + packkagee.name + "/Dataregister";
                        }
                      }
                    });
                } else {
                  window.location.href =
                    admission + "/student_creckregister?ic=" + studentok[0]["ID_LOGIN"];
                }
              }
            });
          } else {
            Swal.fire({
              icon: "success",
              title: "มหาวิทยาลัยฯ จะประกาศรายชื่อผู้ผ่านการคัดเลือก",
              text: "ภายในวันที่ 3 พฤษภาคม 2568 เวลา 18.00 น. ",
            });
          }
        } else {
          Swal.fire({
            icon: "info",
            html: "<div><div style='font-size:18px;font-weight:700;'>อยู่ระหว่างการประมวลผลผู้ผ่านการคัดเลือกหลักสูตรผู้ช่วยพยาบาล</div></div>",
          });
        }
        // } else {
        //   this.setState({ status: studentok.length });
        //   Swal.fire({
        //     icon: "info",
        //     title: "กำลังปรับปรุงระบบ"
        //   });
        // }
      } else {
        if (this.state.citizent === "1100200331318") {
          Swal.fire({
            icon: "warning",
            title: "กำลังปรับปรุงระบบ",
          });
        } else {
          this.setState({ status: studentok.length });
          Swal.fire({
            icon: "info",
            title: "ไม่พบข้อมูลของ : " + this.state.citizent,
          });
        }
      }
    });
  }

  render() {
    return (
      <>
        <MetaTags>
          <title>มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
          <meta
            name="description"
            content="มหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University"
          />
          <meta property="og:title" content="มหาวิทยาลัยราชภัฏกำแพงเพชร" />
          <meta property="og:image" content="../../public/favicon.ico" />
        </MetaTags>
        <br />
        <Pane display="flex" justifyContent="center">
          <Pane className="col-lg-4 col-md-6 col-sm-8 col-12">
            <Pane
              className="my-2 py-2 "
              display="flex"
              justifyContent="center"
              fontFamily=""
              fontWeight="500"
              fontSize="22px"
              color="#5a189a"
              boxShadow="0px 0px 10px #00000030"
              borderRadius={6}
              alignItems="center"
              gap={10}
            >
              <BsCardChecklist /> {this.state.titlename} / ชำระเงินค่าสมัคร
            </Pane>
            {/* {sadjfhsdkjf}sa */}

            <Pane borderRadius={6} className="p-3" boxShadow="0px 0px 10px #00000030">
              {/* <h3 style={{ textAlign: "center" }}>อยู่ระหว่างการปรับปรุงระบบ</h3>
              <h3 style={{ textAlign: "center" }}>มหาวิทยาลัยฯ จะประกาศรายชื่อผู้ผ่านการคัดเลือก วันที่ 30 มกราคม 2569 เวลา 18.00 น.</h3> */}
              <form onSubmit={this.handleSubmit}>
                <div className="form-outline">
                  <label className="form-label" for="citizent">
                    รหัสเลขบัตรประชาชน/เลขบัตร Passport{" "}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="citizent"
                    name="citizent"
                    placeholder="รหัสเลขบัตรประชาชน/เลขบัตร Passport"
                    onChange={this.handleChange}
                    required
                  />
                </div>
                <br />
                <Button
                  width="100%"
                  type="submit"
                  iconBefore={<AiOutlineFileSearch />}
                  appearance=""
                  backgroundColor="#e2cfea"
                  color="#5b2a86"
                  fontWeight="500"
                  fontSize="14px"
                  fontFamily=""
                >
                  ตรวจสอบสถานะ
                </Button>
              </form>
            </Pane>
          </Pane>
        </Pane>

        <br />
      </>
    );
  }
}
